'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_RecipeNutrition(recipeId_$_lo, recipeId_$_hi, perServing, matchedIngredients, totalIngredients, matchedItems) {
  this.NF = 0;
  this.NG = 0;
  this.D0 = null;
  this.wE = 0;
  this.zf = 0;
  this.ze = null;
  this.NF = recipeId_$_lo;
  this.NG = recipeId_$_hi;
  this.D0 = perServing;
  this.wE = matchedIngredients;
  this.zf = totalIngredients;
  this.ze = matchedItems;
}
export { $c_Lmealorama_RecipeNutrition as $c_Lmealorama_RecipeNutrition };
$p = $c_Lmealorama_RecipeNutrition.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_RecipeNutrition;
/** @constructor */
function $h_Lmealorama_RecipeNutrition() {
}
export { $h_Lmealorama_RecipeNutrition as $h_Lmealorama_RecipeNutrition };
$h_Lmealorama_RecipeNutrition.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 905272714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.NF, this.NG)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.D0));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.wE);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.zf);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.ze));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_RecipeNutrition)) {
    if (((this.wE === x$0.wE) && (this.zf === x$0.zf))) {
      var x_$_lo = this.NF;
      var x_$_hi = this.NG;
      var $x_3 = x$0;
      var x$1_$_lo = $x_3.NF;
      var x$1_$_hi = $x_3.NG;
      var $x_2 = (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$2 = this.D0;
      var x$2$1 = x$0.D0;
      var $x_1 = ((x$2 === null) ? (x$2$1 === null) : x$2.f(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.ze;
      var x$4 = x$0.ze;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 5;
});
$p.r = (function() {
  return "RecipeNutrition";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.NF, this.NG);
      break;
    }
    case 1: {
      return this.D0;
      break;
    }
    case 2: {
      return this.wE;
      break;
    }
    case 3: {
      return this.zf;
      break;
    }
    case 4: {
      return this.ze;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_RecipeNutrition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jM)));
}
export { $isArrayOf_Lmealorama_RecipeNutrition as $isArrayOf_Lmealorama_RecipeNutrition };
var $d_Lmealorama_RecipeNutrition = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_RecipeNutrition, "mealorama.RecipeNutrition", ({
  jM: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_RecipeNutrition as $d_Lmealorama_RecipeNutrition };
//# sourceMappingURL=mealorama.-Recipe-Nutrition.js.map
